import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createPersonMartialStatus,
  updatePersonMartialStatus,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const usePersonMartialStatusDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const personMartialStatusDispatch = ({
    personUid,
    data,
    defaultValues,
    onSuccess,
  }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      PersonUid: personUid,
      data,
      onSuccess,
    };

    if (defaultValues.MaritalStatus) {
      dispatch(
        updatePersonMartialStatus({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createPersonMartialStatus({
        ...requestData,
      }),
    );
  };

  return { personMartialStatusDispatch };
};

export default usePersonMartialStatusDispatch;
